<template>
  <ui-dialog
    :show="isOpen"
    :closable="false"
    persistent
    scrollable
    max-width="623"
    @input="close"
  >
    <template #header>
      <h3>
        {{ $t("message.facilityCreate.dialog.inCenter.title") }}
      </h3>
    </template>
    <template #default>
      <p>
        {{
          $t("message.facilityCreate.dialog.inCenter.paragraphFirst", {
            account: facilityData.gmb_email,
            profile: facilityData.gmb_profile_name
          })
        }}
      </p>
      <p>
        {{ $t("message.facilityCreate.dialog.inCenter.paragraphSecond") }}
      </p>
    </template>
    <template #actions>
      <div class="d-flex justify-center w-100">
        <ui-button color="primary" class="mr-3" outlined @click="close">
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button
          v-if="facilityData && facilityData.id"
          color="primary"
          class="ml-3"
          @click="handleRedirect"
        >
          {{ $t("message.facilityCreate.dialog.inCenter.goToEditView") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "InCenterDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    facilityData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },

    handleRedirect() {
      this.close();

      this.$router.push({
        name: "facility-details",
        params: { id: this.facilityData.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  width: 90%;
  margin: 0 auto;
  line-height: 28px;
  text-align: center;
}

p {
  @include font-size(16px);
  font-weight: 500;
  text-align: center;
}
</style>
